import cuid from "cuid";
import { defaultsDeep, get } from "lodash";
import { useMemo } from "react";
import { JOB_LIST, SKILL_TYPES } from "utils/constants";
import Navbar from "../Components/Navbar/Navbar";
import ViewActive from "./ViewActive";
import ViewFPH from "./ViewFPH";
import ViewHPractitioner from "./ViewHPractitioner";
import ViewRetired from "./ViewRetired";

const VIEWS = {
  DEFAULT: ViewActive,
  [JOB_LIST.RETIRED]: ViewRetired,
  [JOB_LIST.HOSPITAL_CIVIL_SERVICE]: ViewFPH,
  [JOB_LIST.HOSPITAL_PRACTITIONER]: ViewHPractitioner,
};

const Income = ({ project, onNext, onBack, currentStatus, tracer }) => {
  const View = useMemo(
    () =>
      VIEWS[project?.contact?.profession] ||
      (get(project, "contact.profession")
        ? VIEWS.DEFAULT
        : VIEWS[JOB_LIST.HOSPITAL_CIVIL_SERVICE]),
    [project?.contact?.profession],
  );

  const isFirstScreen = useMemo(
    () =>
      Number(get(currentStatus, "order")) ===
      Math.min(
        ...get(currentStatus, "process.processStatuses", []).map(({ order }) =>
          Number(order),
        ),
      ),
    [],
  );

  const onSubmit = (contact) => {
    const establishment = get(contact, "fields.establishment") || "";
    const skills = Object.keys(get(project, "fields.skills", {})).includes(
      SKILL_TYPES.ESTABLISHMENT,
    )
      ? {
          ...get(project, "fields.skills", {}),
          [SKILL_TYPES.ESTABLISHMENT]: establishment,
        }
      : get(project, "fields.skills", {});

    onNext({
      payload: {
        contact,
        fields: { ...get(project, "fields", {}), skills },
      },
    });
  };

  return (
    <>
      <Navbar
        project={project}
        progress={currentStatus?.progress}
        tracer={tracer}
      />
      <View
        contact={defaultsDeep(get(project, "contact", {}), {
          id: cuid(),
          profession: JOB_LIST.HOSPITAL_CIVIL_SERVICE,
          user: {
            id: cuid(),
          },
        })}
        onSubmit={onSubmit}
        onBack={onBack}
        isFirstScreen={isFirstScreen}
      />
    </>
  );
};

export default Income;
